module.exports = __webpack_public_path__ + "static/img/wap_home_4.c6c9532.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/mExtensionPage/wap_home_4.png
// module id = dmyl
// module chunks = 0